module.exports = __webpack_public_path__ + "img/large_red_bricks_diff_1k.7514a48c.jpg";